import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class CajaService {
  constructor(protected http: HttpClient) {}

  public get(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.serverUrl}api/caja/get`, {});
  }

  public getHistorial(i: string): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/caja/getHistorial`,
      {
        params: { i },
      }
    );
  }

  public add(defa: any): Observable<any> {
    const options = {
      headers: new HttpHeaders({ "Content-Type": "application/json" }),
    };
    return this.http.post<any>(
      `${environment.serverUrl}api/caja/add`,
      defa,
      options
    );
  }
}
